import { render, staticRenderFns } from "./CreateNewProgramDialog.vue?vue&type=template&id=ca096d9a&scoped=true&lang=pug"
import script from "./CreateNewProgramDialog.vue?vue&type=script&lang=js"
export * from "./CreateNewProgramDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateNewProgramDialog.vue?vue&type=style&index=0&id=ca096d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca096d9a",
  null
  
)

export default component.exports